import RIGHT_ARROW from '../../../../../assets/img/arrow-right-line-icon.svg'

const ListViewComponent = ({ list, onListItemClick, selectedIndex }) => {


    const handleItemClick = (item, index) => {
        onListItemClick(item, index);
    };

    return (
        <div className="overflow-scroll w-full h-full mt-0">
            <ul>
                {list.map((item, index) => (
                    <li
                        key={index}
                        onClick={() => handleItemClick(item, index)}
                        className={`flex flex-row justify-between items-center gap-4 list-none p-4 mb-2 cursor-pointer rounded-3xl shadow-md
                ${selectedIndex === index ? 'bg-header_bg' : 'bg-bodybgrnd'}`}
                    >
                        <div className="flex flex-col content-center">
                            <div className="flex flex-row gap-4">
                                <div className="flex-1 justify-center">
                                    <span className={`text-xs md:text-base ml-1 ${selectedIndex === index ? 'text-white' : 'text-darkclr'}`}>
                                        {item.pat_name}
                                    </span>
                                    {item.pat_acct_num && <span className="text-xs md:text-sm ml-1">, {item.pat_acct_num}</span>}
                                </div>
                            </div>

                            {item.pat_dob && (
                                <div className="flex flex-row gap-4">
                                    <div className="w-32 flex flex-row">
                                        <div style={{ width: '90%' }}>
                                            <span className="text-xs md:text-sm ml-1">
                                                DOB
                                            </span>
                                        </div>
                                        <div style={{ width: '10%' }}>
                                            <span className="text-xs md:text-sm ml-1">
                                                :
                                            </span>
                                        </div>
                                    </div>
                                    <div className="w-full">
                                        <label className={`text-xs md:text-sm ml-1 
                        ${selectedIndex === index ? 'text-white' : 'text-darkclr'}`}
                                        >
                                            {item.pat_dob}
                                        </label>
                                    </div>
                                </div>
                            )}

                            {item.drg && (
                                <div className="flex flex-row gap-4">
                                    <div className="w-32 flex flex-row">
                                        <div style={{ width: '90%' }}>
                                            <span className="text-xs md:text-sm ml-1">
                                                Drug
                                            </span>
                                        </div>
                                        <div style={{ width: '10%' }}>
                                            <span className="text-xs md:text-sm ml-1">
                                                :
                                            </span>
                                        </div>
                                    </div>
                                    <div className="w-full">
                                        <label className={`text-xs md:text-sm ml-1 
                        ${selectedIndex === index ? 'text-white' : 'text-darkclr'}`}
                                        >
                                            {item.drg}
                                        </label>
                                    </div>
                                </div>
                            )}

                            {item.provider && (
                                <div className="flex flex-row gap-4">
                                    <div className="w-32 flex flex-row">
                                        <div style={{ width: '90%' }}>
                                            <span className="text-xs md:text-sm ml-1">
                                                Provider
                                            </span>
                                        </div>
                                        <div style={{ width: '10%' }}>
                                            <span className="text-xs md:text-sm ml-1">
                                                :
                                            </span>
                                        </div>
                                    </div>
                                    <div className="w-full">
                                        <label className={`text-xs md:text-sm ml-1 
                        ${selectedIndex === index ? 'text-white' : 'text-darkclr'}`}>{item.provider}</label>
                                    </div>
                                </div>
                            )}

                            {item.fac_name && (
                                <div className="flex flex-row gap-4">
                                    <div className="w-32 flex flex-row">
                                        <div style={{ width: '90%' }}>
                                            <span className="text-xs md:text-sm ml-1">
                                                Facility
                                            </span>
                                        </div>
                                        <div style={{ width: '10%' }}>
                                            <span className="text-xs md:text-sm ml-1">
                                                :
                                            </span>
                                        </div>
                                    </div>
                                    <div className="w-full">
                                        <label className={`text-xs md:text-sm ml-1 
                        ${selectedIndex === index ? 'text-white' : 'text-darkclr'}`}>{item.fac_name}</label>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="flex content-center justify-center">
                            {selectedIndex === index &&
                                <img
                                    className="h-7 w-7 cursor-pointer"
                                    alt=""
                                    src={RIGHT_ARROW}
                                />
                            }
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default ListViewComponent;